/**
 * Reprogramações marcadas para conferir (Cenário do PCP), conferidas contra
 * a planilha lida agora: aplicado, divergiu ou pendente. Só aparece para
 * quem pode reprogramar e só quando há marcas neste aparelho.
 */
import React from "react";

import { estadoDaMarca } from "./apresentacaoSimulacao";
import { Bloco, BotaoTexto, ListaRecuada, Regua } from "./styles";
import { ListaComPonto } from "./stylesSimulacao";

export default function BlocoConferencia({ itens, onEsquecer }) {
  if (!itens?.length) return null;
  return (
    <Bloco aria-label="Reprogramações para conferir">
      <h2>
        Reprogramações para conferir <span>{itens.length}</span>
      </h2>
      <Regua>
        Marcadas por você neste aparelho no Cenário do PCP (ficam depois de sair da conta) e conferidas a cada
        leitura da planilha. As aplicadas saem no dia seguinte; as com mais de 30 dias saem sozinhas.
      </Regua>
      <ListaRecuada>
        <ListaComPonto style={{ padding: "8px 0" }}>
          {itens.map((marca) => {
            const estado = estadoDaMarca(marca);
            return (
              <li key={`${marca.chave}|${marca.campo}`} data-status={marca.status}>
                <i data-tom={estado.tom} aria-hidden="true" />
                <span>
                  {marca.rotulo || marca.chave} · {estado.esperado}: <strong>{estado.texto}</strong>
                  <BotaoTexto type="button" onClick={() => onEsquecer(marca)} style={{ marginLeft: 8, minHeight: 0, padding: 0 }}>
                    Esquecer
                  </BotaoTexto>
                </span>
              </li>
            );
          })}
        </ListaComPonto>
      </ListaRecuada>
    </Bloco>
  );
}
